














































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  getNotificationsDocId,
  sendReadNotificationsDoc,
} from '@/api/notifications';
import { NotificationDocModule } from '@/store/modules/notificationsDocuments';
import { getFileLink } from '@/api/filestorage';
import PreLoader from '@/components/base/PreLoader.vue';

// {
//     "id": "333",
//      отправитель
//     "senderLastName": "Петров",
//     "senderName": "Федор",
//     "senderMiddleName": "Федорович",
//     "senderOrgName": "ООО Рога и копыта"

//      представитель
//     "trusteeLastName": "Цветков"
//     "trusteeMiddleName": "Савельевич"
//     "trusteeName": "Леонид"

//      натариус
//      "notaryLastName": "Гаврилов",
//      "notaryName": "Гаврил",
//      "notaryMiddleName": "Гаврилович",

//      получатель
//     "recipientLastName": "Соловьев",
//     "recipientName": "Станислав",
//     "recipientMiddleName": "Олегович",

//     "recipientInn": "1111111111",
//     "recipientEmail": "eee@sss.ww",
//     "fileLink": "qqq/qq/q",
//     "createDate": "11.03.2021 19:23:36",
//     "isNew": false
//     "notarySentDate": "12.03.2021 19:23:36",
//     "statementDate": "11.03.2021 12:14:44",
//     "statementId": "1102-2928-183",
//     "regionCode": "30",
//     "districtId": "7",
//     "chamberId": "004",
//     "notaryDistrictName": "Икрянинский район"
// }

@Component({
  components: {
    PreLoader,
  },
  data() {
    return {
      getFileLink,
    };
  },
})
export default class NotificationsDocumentsDetail extends Vue {
  @Prop() private id!: string;
  data = {};
  loading: boolean = false;

  async mounted() {
    this.loading = true;
    const data = await getNotificationsDocId(this.id);
    this.data = data
      ? {
          ...data,
          fullSender:
            data.senderLastName && data.senderName
              ? `${data.senderLastName} ${data.senderName} ${
                  data.senderMiddleName ? data.senderMiddleName : ''
                }`
              : null,
          fullRecipient:
            data.recipientLastName && data.recipientName
              ? `${data.recipientLastName} ${data.recipientName} ${
                  data.recipientMiddleName ? data.recipientMiddleName : ''
                }`
              : null,
          fullNotary:
            data.notaryLastName && data.notaryName
              ? `${data.notaryLastName} ${data.notaryName} ${
                  data.notaryMiddleName ? data.notaryMiddleName : ''
                }`
              : null,
          fullTrustee:
            data.trusteeLastName && data.trusteeName
              ? `${data.trusteeLastName} ${data.trusteeName} ${
                  data.trusteeMiddleName ? data.trusteeMiddleName : ''
                }`
              : null,
          notarySentDateCustom: data?.notarySentDate?.split(' ')[0],
          statementDateCustom: data?.statementDate?.split(' ')[0],
        }
      : {};
    this.loading = false;

    if (data.isNew) {
      await sendReadNotificationsDoc([this.id]);
      await NotificationDocModule.getNotificationsDocNew();
    }
  }
}
